var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostGraphile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    shapeRendering: "geometricPrecision",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M100 615L25 360 260 25l455 590z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ba8ff",
    d: "M25 360L260 25l340 105 115 485z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M260 25l340 105L940 25 715 615z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M600 130L940 25l235 335-460 255z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ba8ff",
    d: "M940 25l235 335-75 255H715z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M1175 360l-75 255-500 440 115-440z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M1100 615l-500 440-500-440h615z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M600 1055L100 615 25 360l690 255z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M100 615L25 360l690 255z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#082744",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M375 740l85 55-135 105zM825 740l-85 55 135 105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ba8ff",
    d: "M325 300L490 96h220L600 450z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M490 96h220l165 204-275 150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166ebf",
    d: "M710 96l165 204v425L600 450z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b457f",
    d: "M875 300v425L710 835 600 450z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c3861",
    d: "M875 725L710 835l-110 295V450z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166ebf",
    d: "M710 835v240l-110 55-110-295 110-385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ba8ff",
    d: "M600 1130l-110-55V835L325 725l275-275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166ebf",
    d: "M490 835L325 725V300l275 150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#468bcc",
    d: "M325 725V300l275 150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#082744",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M490 96h220l165 204v425L710 835v240l-110 55-110-55V835L325 725V300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385 415l130 40-130 50zM815 415l-130 40 130 50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostGraphile);
export default __webpack_public_path__ + "static/media/PostGraphile.0478a573.svg";
export { ForwardRef as ReactComponent };